import React from 'react';

import PATHS from 'constants/paths';
import PremiumExercisesPageChecker from 'containers/PremiumExercisesPageChecker/PremiumExercisesPageChecker';
import useSheetsTimerSync from 'uniqueComponents/Sheets/SheetsTimer/useSheetsTimerSync';

function SheetsContent() {
  useSheetsTimerSync();

  return <PremiumExercisesPageChecker from={PATHS.SHEETS} />;
}

export default SheetsContent;
